
import { Component, Vue, Prop } from 'vue-property-decorator'
import {
  getMerchantManagerList,
  delMerchantManager,
  setMerchantManager
  , getMerchantManagerAuthList } from '@/api/merchant/manager'
import editManager from './editManager.vue'
import secret from './secret.vue'
import pagination from '@/components/Pagination/index.vue'
import auth from './auth.vue'
import { statusList } from '@/utils/constant'

import { operationMessage } from '@/utils/message'
import { isShowDialog } from '@/utils/permission'
import { AppModule } from '@/store/modules/app'
import { getMerchant } from '@/api/merchant/merchant'

@Component({
  name: 'managerList',
  components: {
    editManager,
    auth,
    pagination,
    secret
  }
})
export default class extends Vue {
  @Prop({ required: true }) merchant_no!: string

  get language () {
    return AppModule.language
  }
  private managerList: any[] = []
  private listLoading: Boolean = false
  private statusList = statusList
  private managerId: any | null = null
  private currentUserPermission: number[] | null = null
  private isAdmin: boolean = false
  private menuAuthList: any[] = []
  private dialogVisible: boolean = false
  private currentId: number | null = null

  private queryForm: any = {
    username: ''
  }
  private total: number = 0
  private listQuery = {
    page: 1,
    limit: 20
  }
  private isAuth: boolean = false // 打开的是授权弹窗
  private action: string = ''
  private back () {
    this.$emit('close')
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange (size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange (currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi () {
    try {
      this.listLoading = true
      const data: any = {
        merchant_no: this.merchant_no,
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage
      }
      await getMerchantManagerList(data).then((res: any) => {
        this.total = res.count
        this.managerList = res.results
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }
  private select () {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  private reset () {
    this.queryForm = {
      username: ''
    }
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  private closeDialog () {
    this.action = ''
    this.managerId = null
    // this.getMerchantManagerList(false)
    this.hadleGetFilesListApi()
  }

  // 打开编辑窗口
  private async openDialog (
    managerId: string | null,
    permissions: number[] | null,
    isAuth: boolean,
    isAdmin?: boolean
  ) {
    if (isAuth) {
      await this.getMenuAuthList(managerId)
    }
    this.isAdmin = isAdmin || false
    this.currentUserPermission = permissions
    this.isAuth = isAuth
    this.managerId = managerId
    this.dialogVisible = true
    if (isAdmin) {
      this.action = ''
    }
  }

  private openDialogVisible (action: string, id: number | null) {
    this.dialogVisible = true
    this.action = action
    if (id !== null) {
      this.currentId = id
    }
  }

  // 获取菜单权限列表
  private async getMenuAuthList (id: any) {
    await getMerchantManagerAuthList(id).then((res: any) => {
      this.menuAuthList = res
    })
  }

  private closeDialogVisible (b: boolean) {
    this.dialogVisible = b
  }

  // 删除账户
  private del (id: number) {
    if (this.language === 'en') {
      this.$confirm('Are you sure to delete it?', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        type: 'warning',
        callback: action => {
          if (action === 'confirm') {
            this.action = 'del'
            isShowDialog('delete_merchant_bank')
              ? this.openDialog(id + '', null, false)
              : this.delMerchantManager({
                merchant_no: this.merchant_no,
                id: id
              })
          }
        }
      })
    }
    if (this.language === 'zh_cn') {
      this.$confirm('确定要删除吗？', {
        confirmButtonText: '是的',
        cancelButtonText: '取消 ',
        type: 'warning',
        callback: action => {
          if (action === 'confirm') {
            this.action = 'del'
            isShowDialog('delete_merchant_bank')
              ? this.openDialog(id + '', null, false)
              : this.delMerchantManager({
                merchant_no: this.merchant_no,
                id: id
              })
          }
        }
      })
    }
    if (this.language === 'zh_tw') {
      this.$confirm('確定要刪除嗎？', {
        confirmButtonText: '是的',
        cancelButtonText: '取消 ',
        type: 'warning',
        callback: action => {
          if (action === 'confirm') {
            this.action = 'del'
            isShowDialog('delete_merchant_bank')
              ? this.openDialog(id + '', null, false)
              : this.delMerchantManager({
                merchant_no: this.merchant_no,
                id: id
              })
          }
        }
      })
    }
  }

  private async delMerchantManager (data) {
    delMerchantManager(data).then(() => {
      operationMessage(true)
    })
  }

  private async operationCb (info: any) {
    if (info) {
      const data: any = {
        id: this.managerId,
        merchant_no: this.merchant_no,
        ...info
      }
      await this.delMerchantManager(data)
    }

    this.dialogVisible = false
  }

  private async setStatus (row: any) {
    this.openDialog(row.id, null, false)
  }

  // 获取银行账户列表
  private async getMerchantManagerList (isReset: boolean) {
    if (isReset) {
      this.listQuery.page = 1
    }
    const data: any = {
      merchant_no: this.merchant_no,
      ...this.queryForm,
      page: this.listQuery.page
    }
    this.listLoading = true
    try {
      await getMerchantManagerList(data).then((res: any) => {
        this.total = res.count
        this.managerList = res.results
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  // 获取商户信息
  private googleAuth: boolean = false
  private async getMerchantInfo () {
    await getMerchant({ merchant_no: this.merchant_no }).then((res: any) => {
      this.googleAuth = res.results[0].google_auth_switch
    })
  }

  created () {
    // this.getMerchantManagerList(true)
    this.getMerchantInfo()
    this.hadleGetFilesListApi()
  }
}
